import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  width: 100%;
  /* 좁은 화면에서 20px 씩 양쪽을 먹으면 카드가 들어갈 자리가 없다.
   * 여백은 index.css 가 화면 폭에 맞춰 정한다. */
  padding: var(--market-gutter);
  min-height: calc(100vh - 400px);
`;

const PageHeader = styled.div`
  margin-bottom: 20px;
  text-align: ${props => props.center ? 'center' : 'left'};
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 6px;
`;

const PageSubtitle = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`;

const PageContent = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: var(--market-gutter);
  min-height: 400px;
`;

function ContentLayout({ 
  title, 
  subtitle, 
  children, 
  centerTitle = false,
  noBackground = false 
}) {
  if (noBackground) {
    return (
      <PageContainer>
        <PageHeader center={centerTitle}>
          {title && <PageTitle>{title}</PageTitle>}
          {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
        </PageHeader>
        {children}
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader center={centerTitle}>
        {title && <PageTitle>{title}</PageTitle>}
        {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
      </PageHeader>
      <PageContent>
        {children}
      </PageContent>
    </PageContainer>
  );
}

export default ContentLayout;